import React from 'react';
import { Endpoint } from '../Endpoint.js';
import FontAwesome from 'react-fontawesome';

export class IASZoneEndpoint extends Endpoint {
  render() {
    return(
      <div className={ this.renderToggleClass() }>
        <div onClick={ this.toggleAccordion } className="single-device__topbar">{ this.renderDeviceType() } <FontAwesome name="plus" className="single-device__topbar__plus" /></div>
        <div className="single-device__content">
          <div className="single-device__content__data">
            { this.getEndpoint() }
            { this.getDeviceId() }
            { this.getId() }
            { this.getProfileName() }
            { this.getManufacturerName() }
            { this.getModelIdentifier() }
            { this.getOnOff() }
            { this.getBattery() }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/endpoints/IASZoneEndpoint.js